export const MENU_OPTIONS = [
  {
    name: "Início",
    icon: "ph ph-chart-pie-slice",
    route: { name: "home" }
  },
  {
    name: "Produtos",
    icon: "ph ph-cube",
    context: "products",
    indicator: "/produto/",
    options: [
      {
        name: "Novo produto",
        route: { name: "product-new" },
        permissions: ["gerenciar-produtos"]
      },
      {
        name: "Meus produtos",
        route: { name: "product" },
        permissions: ["gerenciar-produtos"]
      }
    ]
  },
  {
    name: "Vendas",
    icon: "ph ph-shopping-cart",
    indicator: "/vendas/",
    context: "sales",
    options: [
      {
        name: "Visão geral",
        route: { name: "sales" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Assinaturas",
        route: { name: "sales-subscriptions" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Cursos",
        route: { name: "sales-courses" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Eventos",
        route: { name: "sales-events" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Recuperação de compras",
        route: { name: "sales-recovery" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Clientes",
        route: { name: "reports-clients" },
        permissions: ["clientes"]
      }
    ],
    permissions: ["acessar-vendas"]
  },
  {
    name: "Relatórios",
    icon: "ph ph-chart-bar",
    indicator: "/relatorios/",
    context: "reports",
    options: [
      {
        name: "Clientes",
        route: { name: "reports-clients" }
      }
    ]
  },
  {
    name: "Próximos lançamentos",
    icon: "ph ph-rocket",
    route: { name: "releases" },
    indicator: "/próximos-lançamentos/",
    permissions: ["proximos-lancamentos"]
  },
  {
    name: "Saldo",
    permissions: ["ver-extrato"],
    icon: "ph ph-wallet",
    route: { name: "balance" },
    indicator: "/saldo/"
  },
  // {
  //   name: "Indique & Ganhe",
  //   custom: true,
  //   permissions: ["indique-e-ganhe"]
  // },
  {
    name: "Ferramentas",
    icon: "ph ph-wrench",
    indicator: "/ferramentas/",
    route: { name: "tools" },
    permissions: [
      "coproducoes",
      "central-de-colaboradores",
      "api-e-notificacoes",
      "webhook-api-e-notificacoes",
      "lead-list",
      "e-mail-marketing",
      "automacoes",
      "notas-fiscais",
      "kajabi",
      "zoom",
      "certificacoes-mec",
      "pixel-de-rastreamento",
      "integracoes"
    ]
  },
  {
    name: "Gestão de assinaturas",
    icon: "ph ph-tree-structure",
    route: { name: "subscriptions-manager" },
    permissions: ["gerenciar-assinaturas"]
  }
];
